import { KEY_REDUCER_SW } from "@/shared/store/sw/constants";

export const selectorIsDownloadingWebsite = (state) => {
  return state[KEY_REDUCER_SW].isWebsiteUrlsDownloading;
};